
import { ref, onMounted, reactive, defineComponent } from 'vue'
import DataTable from '@/views/components/table/HjpDataTable.vue'
import Form from './Form.vue'

export default defineComponent({
  components: {
    DataTable,
    Form
  },
  setup() {
    const tabelParams = reactive({
      endpoint: '/talent/v1/penaltyAdjustmentCategories',
      headerTitle: 'Master Kategori Denda',
      buttonTitle: '',
      editTitle: 'Edit',
      deleteTitle: 'Hapus',
      confirmDialogDelete: {
        title: 'Hapus Kategori Denda?',
        subTitle: 'Data Kategori Denda tersebut akan dihapus dalam sistem. Yakin hapus Kategori Denda?',
        btnSubmitTitle: 'Hapus Kategori Denda',
      },
      columnsTable: [
        {
          field: 'name',
          headerName: 'Nama Kategori Denda',
          searchable: true,
          fieldSearch: 'Name',
          isRender: true,
          style: { maxWidth: '900px' }
        },
        {
          field: 'code',
          headerName: 'Kode',
          searchable: true,
          fieldSearch: null,
          isRender: false
        },
        {
          field: 'adjustmentType',
          headerName: 'Tipe Denda',
          searchable: true,
          fieldSearch: null,
          isRender: true
        },
      ]
    })

    const onDeleteFailedMessage = ref({
      summary: 'Data kategori denda tidak bisa dihapus!',
      detail: 'Data kategori denda saat ini sedang aktif sehingga tidak bisa dihapus'
    })
    const onDeleteSuccessMessage = ref({
      summary: 'Data kategori denda berhasil dihapus!',
      detail: 'Data kategori denda telah berhasil dihapus dalam sistem'
    })
    // const slotBank = 'MsBank.Name'
    // const slotChannelBank = 'MsChannelBanks.OaAccount'
    // const getBankChannelId = (data: any) => {
    //   console.log('data', data)
    // }
    return {
      tabelParams,
      onDeleteFailedMessage,
      onDeleteSuccessMessage
    }
  }
})
